import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { AllPatientTabDispatchTypes } from "../../../models/DispatchTypes/AllPatientRecord";
import { ApplicationState } from "../../../store/ApplicationState";
import PhysicianInputForm from "../components/PhysicianInputForm";
import { resetStates } from "../../../actions/Common";

const mapDispatchToProps = (
  dispatch: ThunkDispatch<
    ApplicationState,
    Record<string, never>,
    AllPatientTabDispatchTypes
  >
) => {
  return {
    resetStates: (actionType: string[]) => {
      dispatch(resetStates(actionType));
    },
  };
};
export default connect(null, mapDispatchToProps)(PhysicianInputForm);
